import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import API from "../../../services/API";

export default function CourseTeachers({id}){

    const [status, setStatus] = useState('loading')

    const [options, setOptions] = useState([])

    const [value, setValue] = useState([])

    useEffect(() => {

        load(id).then(data => {

            setOptions(data.options)
            setValue(data.value)
            setStatus('ready')

        })
        .catch(_ => setStatus('error'))

    }, [id])

    const handleChange = (_, newValue) => {
        
        const previousValue = [...value];

        setValue(newValue)

        API.post(`/courses/${id}/teachers`, newValue)
            .catch(_ => setValue(previousValue))
    }


    return status === 'ready' &&

        <Autocomplete
            multiple
            options={options}
            value={value}
            onChange={handleChange}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            renderInput={(params) => 
                <TextField 
                    {...params} 
                    label="Intervenants"
                    size='small'
                />
            }
        />
}


async function load(id){

    let data = {options: [], value: []};

    let response1 = await API.get(`/teachers`);

    data.options = response1.data.map(user => {
        return {id: user.id, label: user.name}
    });

    let response2 = await API.get(`/courses/${id}/teachers`);

    data.value = response2.data.map(user => {
        return {id: user.id, label: user.name}
    });

    return data;
}